import React from 'react';
import { Row, Col, Card, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
//icons
import { MdPlace } from 'react-icons/md';
import { HiMail } from 'react-icons/hi';
import { FaGlobe } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { AiOutlineFacebook, AiOutlineInstagram } from 'react-icons/ai';
//helpers
import { truncate } from 'helpers';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import Button from 'components/backoffice/buttonCustom';
//styles
import './libraryCard.scss';

const LibraryCard = ({ library = null }) => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const { assignedLibrary } = useAssignedLibrary();

  const handleSeeMore = () => {
    navigate(`/${assignedLibrary}/library/${library.id}`);
  };

  return (
    <Row className="library-card mt-4 mt-sm-0">
      <Card>
        <Row className="info-row">
          <Col lg={12} className="text-center py-2">
            <h3 className="library-name mt-0">
              <strong>{truncate(library.name, 20)}</strong>
            </h3>
          </Col>
          <Col className="img-col" style={{ backgroundImage: `url('${library?.logo || ''}')` }} lg={12}></Col>
          <Col lg={12} className="container-content">
            <ListGroup className="w-100 px-0 d-flex ">
              <ListGroup.Item className="bg-gray-light d-flex align-items-center fixed-height">
                {(library?.direccion || library?.city || library?.pais?.nombre) && (
                  <>
                    <MdPlace className="me-2" />
                    {library?.direccion && truncate(library.direccion, 29)}
                    {library?.direccion && (library?.city || library?.pais?.nombre) && ', '}
                    {library?.city}
                    {library?.city && library?.pais?.nombre && ', '}
                    {library?.pais?.nombre}.
                  </>
                )}
                {!(library?.direccion || library?.city || library?.pais?.nombre) && (
                  <>
                    <MdPlace className="me-2" />
                    {t('locationNotAvailable')}
                  </>
                )}
              </ListGroup.Item>
            </ListGroup>
            <Col className="icons-col d-flex align-items-end" lg={12}>
              <div>
                {library.email ? (
                  <a href={`mailto:${library.email}`} target="_blank" className="link-icon">
                    <HiMail />
                  </a>
                ) : (
                  <span className="empty-link-icon">
                    <HiMail />
                  </span>
                )}
              </div>
              <div>
                {library?.redes_sociales?.twitter ? (
                  <a target="_blank" href={library.redes_sociales.twitter} className="link-icon">
                    <FaXTwitter />
                  </a>
                ) : (
                  <span className="empty-link-icon">
                    <FaXTwitter />
                  </span>
                )}
              </div>
              <div>
                {library?.redes_sociales?.instagram ? (
                  <a target="_blank" href={library.redes_sociales.instagram} className="link-icon">
                    <AiOutlineInstagram />
                  </a>
                ) : (
                  <span className="empty-link-icon">
                    <AiOutlineInstagram />
                  </span>
                )}
              </div>
              <div>
                {library?.redes_sociales?.facebook ? (
                  <a target="_blank" href={library.redes_sociales.facebook} className="link-icon">
                    <AiOutlineFacebook />
                  </a>
                ) : (
                  <span className="empty-link-icon">
                    <AiOutlineFacebook />
                  </span>
                )}
              </div>
              <div>
                {library.web_url ? (
                  <a target="_blank" href={library.web_url} className="link-icon">
                    <FaGlobe />
                  </a>
                ) : (
                  <span className="empty-link-icon">
                    <FaGlobe />
                  </span>
                )}
              </div>
            </Col>
            <Col lg={12} className="d-flex justify-content-center">
              <Button className="btn-primary text-decoration-none w-100 see-more-button" onClick={handleSeeMore}>
                {t('seeMore')}
              </Button>
            </Col>
          </Col>
        </Row>
      </Card>
    </Row>
  );
};

export default LibraryCard;